// removed by extract-text-webpack-plugin
module.exports = {"shadeMedium":"rgb(142, 141, 142)","panel":"tab-panel__panel____1tmB7","accordion":"tab-panel__accordion____1Tc3n"};


//////////////////
// WEBPACK FOOTER
// ./src/admin/ui/components/tab-panel/tab-panel.css
// module id = 434
// module chunks = 0